import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ScreenSizeService } from '@core/services';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet />`,
  styleUrl: './app.scss',
})
export class AppRoot implements OnInit {
  private readonly screenSizeService = inject(ScreenSizeService);

  ngOnInit(): void {
    this.screenSizeService.checkScreenSize();
  }
}
